import { render, staticRenderFns } from "./Financas.vue?vue&type=template&id=68b57935&scoped=true&"
import script from "./Financas.vue?vue&type=script&lang=js&"
export * from "./Financas.vue?vue&type=script&lang=js&"
import style0 from "./Financas.vue?vue&type=style&index=0&id=68b57935&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b57935",
  null
  
)

export default component.exports